export const environment = {
  production: false,
  webUrl: 'https://web--marigrp-web-dev.us-east4.hosted.app',
};
